export { default } from './SpecialistPicture';
